export const COPY_SUCCESS='Password succesfully copied to clipboard'